import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * PWA entry router (manifest `start_url`). Deterministically routes the
 * installed app to the right experience WITHOUT ever showing the seller
 * dashboard to a buyer:
 *   • Seller session (fab_token)          → /dashboard
 *   • Existing buyer (fabtexs.buyer.id)   → /me (buyer home)
 *   • Chosen role 'seller'                → /login (existing seller flow)
 *   • Chosen role 'buyer'                 → /me (buyer home)
 *   • First launch (no signal at all)     → /welcome (Buyer/Seller gate)
 * Role selection is deterministic (no AI). The chosen role persists in
 * localStorage under `fabtexs.role`, so returning users never re-see the gate.
 */
export default function Start() {
  let token = null, buyer = null, role = null;
  try { token = localStorage.getItem('fab_token'); } catch (_e) {}
  try { buyer = localStorage.getItem('fabtexs.buyer.id'); } catch (_e) {}
  try { role = localStorage.getItem('fabtexs.role'); } catch (_e) {}
  if (token) return <Navigate to="/dashboard" replace />;
  if (buyer) return <Navigate to="/me" replace />;
  if (role === 'seller') return <Navigate to="/login" replace />;
  if (role === 'buyer') return <Navigate to="/me" replace />;
  return <Navigate to="/welcome" replace />;
}
